"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractSecurity = exports.ContractFeatures = exports.VestingContractFeatures = exports.VestingContractTemplates = exports.StakingContractTemplates = exports.StakingContractFeatures = exports.PredictionContractTemplates = exports.PredictionContractFeatures = exports.PonziContractTemplates = exports.PonziContractFeatures = exports.CollectionContractTemplates = exports.CollectionContractFeatures = exports.LootContractTemplates = exports.LootContractFeatures = exports.MysteryContractTemplates = exports.MysteryContractFeatures = exports.Erc1155ContractTemplates = exports.Erc1155ContractFeatures = exports.Erc998ContractTemplates = exports.Erc998ContractFeatures = exports.Erc721ContractTemplates = exports.Erc721ContractFeatures = exports.Erc20ContractTemplates = exports.Erc20ContractFeatures = exports.NativeContractTemplates = exports.NativeContractFeatures = exports.ContractStatus = void 0;
var ContractStatus;
(function (ContractStatus) {
    ContractStatus["ACTIVE"] = "ACTIVE";
    ContractStatus["INACTIVE"] = "INACTIVE";
    ContractStatus["NEW"] = "NEW";
})(ContractStatus || (exports.ContractStatus = ContractStatus = {}));
var NativeContractFeatures;
(function (NativeContractFeatures) {
})(NativeContractFeatures || (exports.NativeContractFeatures = NativeContractFeatures = {}));
var NativeContractTemplates;
(function (NativeContractTemplates) {
    NativeContractTemplates["SIMPLE"] = "SIMPLE";
})(NativeContractTemplates || (exports.NativeContractTemplates = NativeContractTemplates = {}));
var Erc20ContractFeatures;
(function (Erc20ContractFeatures) {
    Erc20ContractFeatures["BLACKLIST"] = "BLACKLIST";
    Erc20ContractFeatures["WHITELIST"] = "WHITELIST";
    Erc20ContractFeatures["VOTES"] = "VOTES";
    Erc20ContractFeatures["EXTERNAL"] = "EXTERNAL";
})(Erc20ContractFeatures || (exports.Erc20ContractFeatures = Erc20ContractFeatures = {}));
var Erc20ContractTemplates;
(function (Erc20ContractTemplates) {
    Erc20ContractTemplates["SIMPLE"] = "SIMPLE";
    Erc20ContractTemplates["BLACKLIST"] = "BLACKLIST";
    Erc20ContractTemplates["WHITELIST"] = "WHITELIST";
    Erc20ContractTemplates["VOTES"] = "VOTES";
    Erc20ContractTemplates["EXTERNAL"] = "EXTERNAL";
})(Erc20ContractTemplates || (exports.Erc20ContractTemplates = Erc20ContractTemplates = {}));
var Erc721ContractFeatures;
(function (Erc721ContractFeatures) {
    Erc721ContractFeatures["BLACKLIST"] = "BLACKLIST";
    Erc721ContractFeatures["DISCRETE"] = "DISCRETE";
    Erc721ContractFeatures["RENTABLE"] = "RENTABLE";
    Erc721ContractFeatures["RANDOM"] = "RANDOM";
    Erc721ContractFeatures["GENES"] = "GENES";
    Erc721ContractFeatures["SOULBOUND"] = "SOULBOUND";
    Erc721ContractFeatures["VOTES"] = "VOTES";
    Erc721ContractFeatures["EXTERNAL"] = "EXTERNAL";
})(Erc721ContractFeatures || (exports.Erc721ContractFeatures = Erc721ContractFeatures = {}));
var Erc721ContractTemplates;
(function (Erc721ContractTemplates) {
    Erc721ContractTemplates["SIMPLE"] = "SIMPLE";
    Erc721ContractTemplates["BLACKLIST"] = "BLACKLIST";
    Erc721ContractTemplates["BLACKLIST_RANDOM"] = "BLACKLIST_RANDOM";
    Erc721ContractTemplates["BLACKLIST_DISCRETE"] = "BLACKLIST_DISCRETE";
    Erc721ContractTemplates["BLACKLIST_RENTABLE"] = "BLACKLIST_RENTABLE";
    Erc721ContractTemplates["BLACKLIST_DISCRETE_RANDOM"] = "BLACKLIST_DISCRETE_RANDOM";
    Erc721ContractTemplates["BLACKLIST_DISCRETE_RENTABLE"] = "BLACKLIST_DISCRETE_RENTABLE";
    Erc721ContractTemplates["BLACKLIST_DISCRETE_RENTABLE_RANDOM"] = "BLACKLIST_DISCRETE_RENTABLE_RANDOM";
    Erc721ContractTemplates["GENES"] = "GENES";
    Erc721ContractTemplates["RANDOM"] = "RANDOM";
    Erc721ContractTemplates["RENTABLE"] = "RENTABLE";
    Erc721ContractTemplates["SOULBOUND"] = "SOULBOUND";
    Erc721ContractTemplates["SOULBOUND_VOTES"] = "SOULBOUND_VOTES";
    Erc721ContractTemplates["VOTES"] = "VOTES";
    Erc721ContractTemplates["METADATA"] = "METADATA";
    Erc721ContractTemplates["DISCRETE"] = "DISCRETE";
    Erc721ContractTemplates["DISCRETE_RANDOM"] = "DISCRETE_RANDOM";
    Erc721ContractTemplates["LOTTERY"] = "LOTTERY";
    Erc721ContractTemplates["RAFFLE"] = "RAFFLE";
})(Erc721ContractTemplates || (exports.Erc721ContractTemplates = Erc721ContractTemplates = {}));
var Erc998ContractFeatures;
(function (Erc998ContractFeatures) {
    Erc998ContractFeatures["BLACKLIST"] = "BLACKLIST";
    Erc998ContractFeatures["DISCRETE"] = "DISCRETE";
    Erc998ContractFeatures["RANDOM"] = "RANDOM";
    Erc998ContractFeatures["RENTABLE"] = "RENTABLE";
    Erc998ContractFeatures["GENES"] = "GENES";
    Erc998ContractFeatures["ERC20OWNER"] = "ERC20OWNER";
    Erc998ContractFeatures["ERC1155OWNER"] = "ERC1155OWNER";
    Erc998ContractFeatures["STATEHASH"] = "STATEHASH";
})(Erc998ContractFeatures || (exports.Erc998ContractFeatures = Erc998ContractFeatures = {}));
var Erc998ContractTemplates;
(function (Erc998ContractTemplates) {
    Erc998ContractTemplates["SIMPLE"] = "SIMPLE";
    Erc998ContractTemplates["BLACKLIST"] = "BLACKLIST";
    Erc998ContractTemplates["BLACKLIST_RANDOM"] = "BLACKLIST_RANDOM";
    Erc998ContractTemplates["BLACKLIST_DISCRETE"] = "BLACKLIST_DISCRETE";
    Erc998ContractTemplates["BLACKLIST_DISCRETE_RANDOM"] = "BLACKLIST_DISCRETE_RANDOM";
    Erc998ContractTemplates["ERC20OWNER"] = "ERC20OWNER";
    Erc998ContractTemplates["ERC1155OWNER"] = "ERC1155OWNER";
    Erc998ContractTemplates["ERC1155OWNER_ERC20OWNER"] = "ERC1155OWNER_ERC20OWNER";
    Erc998ContractTemplates["GENES"] = "GENES";
    Erc998ContractTemplates["RANDOM"] = "RANDOM";
    Erc998ContractTemplates["RENTABLE"] = "RENTABLE";
    Erc998ContractTemplates["STATEHASH"] = "STATEHASH";
    Erc998ContractTemplates["DISCRETE"] = "DISCRETE";
    Erc998ContractTemplates["DISCRETE_RANDOM"] = "DISCRETE_RANDOM";
})(Erc998ContractTemplates || (exports.Erc998ContractTemplates = Erc998ContractTemplates = {}));
var Erc1155ContractFeatures;
(function (Erc1155ContractFeatures) {
    Erc1155ContractFeatures["BLACKLIST"] = "BLACKLIST";
    Erc1155ContractFeatures["SOULBOUND"] = "SOULBOUND";
    Erc1155ContractFeatures["EXTERNAL"] = "EXTERNAL";
})(Erc1155ContractFeatures || (exports.Erc1155ContractFeatures = Erc1155ContractFeatures = {}));
var Erc1155ContractTemplates;
(function (Erc1155ContractTemplates) {
    Erc1155ContractTemplates["SIMPLE"] = "SIMPLE";
    Erc1155ContractTemplates["BLACKLIST"] = "BLACKLIST";
    Erc1155ContractTemplates["SOULBOUND"] = "SOULBOUND";
})(Erc1155ContractTemplates || (exports.Erc1155ContractTemplates = Erc1155ContractTemplates = {}));
var MysteryContractFeatures;
(function (MysteryContractFeatures) {
    MysteryContractFeatures["BLACKLIST"] = "BLACKLIST";
    MysteryContractFeatures["PAUSABLE"] = "PAUSABLE";
})(MysteryContractFeatures || (exports.MysteryContractFeatures = MysteryContractFeatures = {}));
var MysteryContractTemplates;
(function (MysteryContractTemplates) {
    MysteryContractTemplates["SIMPLE"] = "SIMPLE";
    MysteryContractTemplates["BLACKLIST_PAUSABLE"] = "BLACKLIST_PAUSABLE";
    MysteryContractTemplates["PAUSABLE"] = "PAUSABLE";
    MysteryContractTemplates["BLACKLIST"] = "BLACKLIST";
})(MysteryContractTemplates || (exports.MysteryContractTemplates = MysteryContractTemplates = {}));
var LootContractFeatures;
(function (LootContractFeatures) {
    LootContractFeatures["BLACKLIST"] = "BLACKLIST";
    LootContractFeatures["PAUSABLE"] = "PAUSABLE";
})(LootContractFeatures || (exports.LootContractFeatures = LootContractFeatures = {}));
var LootContractTemplates;
(function (LootContractTemplates) {
    LootContractTemplates["SIMPLE"] = "SIMPLE";
    LootContractTemplates["BLACKLIST_PAUSABLE"] = "BLACKLIST_PAUSABLE";
    LootContractTemplates["PAUSABLE"] = "PAUSABLE";
    LootContractTemplates["BLACKLIST"] = "BLACKLIST";
})(LootContractTemplates || (exports.LootContractTemplates = LootContractTemplates = {}));
var CollectionContractFeatures;
(function (CollectionContractFeatures) {
    CollectionContractFeatures["BLACKLIST"] = "BLACKLIST";
})(CollectionContractFeatures || (exports.CollectionContractFeatures = CollectionContractFeatures = {}));
var CollectionContractTemplates;
(function (CollectionContractTemplates) {
    CollectionContractTemplates["SIMPLE"] = "SIMPLE";
    CollectionContractTemplates["BLACKLIST"] = "BLACKLIST";
})(CollectionContractTemplates || (exports.CollectionContractTemplates = CollectionContractTemplates = {}));
var PonziContractFeatures;
(function (PonziContractFeatures) {
    PonziContractFeatures["REFERRAL"] = "REFERRAL";
    PonziContractFeatures["SPLITTER"] = "SPLITTER";
})(PonziContractFeatures || (exports.PonziContractFeatures = PonziContractFeatures = {}));
var PonziContractTemplates;
(function (PonziContractTemplates) {
    PonziContractTemplates["SIMPLE"] = "SIMPLE";
    PonziContractTemplates["REFERRAL"] = "REFERRAL";
    PonziContractTemplates["LINEAR_REFERRAL"] = "LINEAR_REFERRAL";
    PonziContractTemplates["SPLITTER"] = "SPLITTER";
})(PonziContractTemplates || (exports.PonziContractTemplates = PonziContractTemplates = {}));
var PredictionContractFeatures;
(function (PredictionContractFeatures) {
    PredictionContractFeatures["REFERRAL"] = "REFERRAL";
    PredictionContractFeatures["SPLITTER"] = "SPLITTER";
})(PredictionContractFeatures || (exports.PredictionContractFeatures = PredictionContractFeatures = {}));
var PredictionContractTemplates;
(function (PredictionContractTemplates) {
    PredictionContractTemplates["SIMPLE"] = "SIMPLE";
    PredictionContractTemplates["REFERRAL"] = "REFERRAL";
})(PredictionContractTemplates || (exports.PredictionContractTemplates = PredictionContractTemplates = {}));
var StakingContractFeatures;
(function (StakingContractFeatures) {
    StakingContractFeatures["SIMPLE"] = "SIMPLE";
})(StakingContractFeatures || (exports.StakingContractFeatures = StakingContractFeatures = {}));
var StakingContractTemplates;
(function (StakingContractTemplates) {
    StakingContractTemplates["SIMPLE"] = "SIMPLE";
    StakingContractTemplates["LINEAR_REFERRAL"] = "LINEAR_REFERRAL";
    StakingContractTemplates["PETAMI"] = "PETAMI";
})(StakingContractTemplates || (exports.StakingContractTemplates = StakingContractTemplates = {}));
var VestingContractTemplates;
(function (VestingContractTemplates) {
    VestingContractTemplates["VESTING"] = "VESTING";
    VestingContractTemplates["VESTING_VOTES"] = "VESTING_VOTES";
})(VestingContractTemplates || (exports.VestingContractTemplates = VestingContractTemplates = {}));
var VestingContractFeatures;
(function (VestingContractFeatures) {
    VestingContractFeatures["SIMPLE"] = "SIMPLE";
    VestingContractFeatures["VOTES"] = "VOTES";
})(VestingContractFeatures || (exports.VestingContractFeatures = VestingContractFeatures = {}));
var ContractFeatures;
(function (ContractFeatures) {
    // SYSTEM
    ContractFeatures["WITHDRAW"] = "WITHDRAW";
    ContractFeatures["ALLOWANCE"] = "ALLOWANCE";
    ContractFeatures["EXTERNAL"] = "EXTERNAL";
    // ERC20
    ContractFeatures["BLACKLIST"] = "BLACKLIST";
    ContractFeatures["WHITELIST"] = "WHITELIST";
    // EC721
    ContractFeatures["DISCRETE"] = "DISCRETE";
    ContractFeatures["GENES"] = "GENES";
    ContractFeatures["RANDOM"] = "RANDOM";
    ContractFeatures["RENTABLE"] = "RENTABLE";
    ContractFeatures["SOULBOUND"] = "SOULBOUND";
    ContractFeatures["VOTES"] = "VOTES";
    ContractFeatures["TRAITS"] = "TRAITS";
    // ERC998
    ContractFeatures["ERC20OWNER"] = "ERC20OWNER";
    ContractFeatures["ERC1155OWNER"] = "ERC1155OWNER";
    ContractFeatures["STATEHASH"] = "STATEHASH";
    // MODULE:MYSTERY
    ContractFeatures["PAUSABLE"] = "PAUSABLE";
    // MODULE:PONZI
    ContractFeatures["REFERRAL"] = "REFERRAL";
    ContractFeatures["SPLITTER"] = "SPLITTER";
    // PORTAL:PAYMENT
    ContractFeatures["STABLE_COIN"] = "STABLE_COIN";
})(ContractFeatures || (exports.ContractFeatures = ContractFeatures = {}));
var ContractSecurity;
(function (ContractSecurity) {
    ContractSecurity["OWNABLE"] = "OWNABLE";
    ContractSecurity["OWNABLE_2_STEP"] = "OWNABLE_2_STEP";
    ContractSecurity["ACCESS_CONTROL"] = "ACCESS_CONTROL";
    ContractSecurity["ACCESS_CONTROL_ENUMERABLE"] = "ACCESS_CONTROL_ENUMERABLE";
    ContractSecurity["ACCESS_CONTROL_DEFAULT_ADMIN_RULES"] = "ACCESS_CONTROL_DEFAULT_ADMIN_RULES";
    ContractSecurity["ACCESS_CONTROL_CROSS_CHAIN"] = "ACCESS_CONTROL_CROSS_CHAIN";
})(ContractSecurity || (exports.ContractSecurity = ContractSecurity = {}));
//# sourceMappingURL=contract.js.map